var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown ? _c("app-toolbar") : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "8", lg: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("name"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.value, "name", $$v)
                                          },
                                          expression: "value.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "8", lg: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          "has-error":
                                            !_vm.vatIsValid &&
                                            _vm.vatNumberBlured,
                                          label: _vm.$ct("vat-number"),
                                          fancy: "",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.onVatBlur()
                                          },
                                        },
                                        model: {
                                          value: _vm.value.vatNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.value,
                                              "vatNumber",
                                              $$v
                                            )
                                          },
                                          expression: "value.vatNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "8", md: "5", lg: "4" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("street"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.streetName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.value,
                                              "streetName",
                                              $$v
                                            )
                                          },
                                          expression: "value.streetName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "4", md: "3", lg: "2" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("street-number"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.streetNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.value,
                                              "streetNumber",
                                              $$v
                                            )
                                          },
                                          expression: "value.streetNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "8", md: "5", lg: "4" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("city"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.cityName,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.value, "cityName", $$v)
                                          },
                                          expression: "value.cityName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "4", md: "3", lg: "2" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("postal"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.postalCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.value,
                                              "postalCode",
                                              $$v
                                            )
                                          },
                                          expression: "value.postalCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "8", lg: "6" } },
                                    [
                                      _c("app-country-code-autocomplete", {
                                        attrs: {
                                          label: _vm.$ct("country-code"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.countryCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.value,
                                              "countryCode",
                                              $$v
                                            )
                                          },
                                          expression: "value.countryCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "8", lg: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("phone"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.phone,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.value, "phone", $$v)
                                          },
                                          expression: "value.phone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "8", lg: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("email"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.value.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.value, "email", $$v)
                                          },
                                          expression: "value.email",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-card-actions",
                            [
                              _c(
                                "w-button",
                                {
                                  staticClass: "cancel",
                                  attrs: { icon: "ban" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.back()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.cancel")) + " "
                                  ),
                                ]
                              ),
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  attrs: { icon: "save" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.save()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.save")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.autoFillData != null } },
        [
          _vm.autoFillData
            ? _c("app-dossier-edit-auto-fill-modal", {
                attrs: { data: _vm.autoFillData },
                on: {
                  close: function ($event) {
                    _vm.autoFillData = null
                  },
                  confirm: function ($event) {
                    return _vm.autoFill($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }